import dayjs from "dayjs";
import {
  BOOKING_ACCENT,
  EVENT_TYPE_ACCENT,
  STATUS_COLORS,
  STATUS_LABELS,
  toEventTypeLabel,
} from "./cardConstants";

export const getEventTypeKey = (event) =>
  String(event?.eventType || "").trim().toUpperCase();

export const getDateRangeLabel = (event) => {
  const begin = event?.eventDateBegin
    ? dayjs(event.eventDateBegin).format("DD.MM.YYYY HH:mm")
    : "";
  const end = event?.eventDateEnd
    ? dayjs(event.eventDateEnd).format("DD.MM.YYYY HH:mm")
    : "";

  if (!begin) return "";
  return end ? `${begin} – ${end}` : begin;
};

export const getEventCardMetrics = (event) => {
  const typeKey = getEventTypeKey(event);
  const isTesting = typeKey === "TESTING";
  const isBooking = event?.registrationType === "booking";

  const bookingRegistrationCount = isBooking
    ? Number(event?.bookingRegistrationCount || 0)
    : 0;
  const bookingParticipantCount = isBooking
    ? Number(event?.bookingParticipantCount || 0)
    : 0;

  const attendeesCount = isTesting
    ? Array.isArray(event?.hasAttendees)
      ? event.hasAttendees.length
      : 0
    : isBooking
    ? bookingParticipantCount
    : Array.isArray(event?.participants)
    ? event.participants.length
    : 0;

  const maxParticipants = Number(event?.maxParticipants) || 0;
  const capacityPercent =
    maxParticipants > 0
      ? Math.min(100, Math.round((attendeesCount / maxParticipants) * 100))
      : 0;

  const rsvpZugesagt = isTesting
    ? Array.isArray(event?.participants)
      ? event.participants.length
      : 0
    : 0;
  const rsvpAbgesagt = isTesting
    ? Array.isArray(event?.rsvpDeclined)
      ? event.rsvpDeclined.length
      : 0
    : 0;
  const rsvpAusstehend = isTesting
    ? Math.max(0, attendeesCount - rsvpZugesagt - rsvpAbgesagt)
    : 0;

  const statusLabel = STATUS_LABELS[event?.status] || event?.status || "";
  const statusColor = STATUS_COLORS[event?.status] || "default";

  const accentColor =
    isBooking && !isTesting
      ? BOOKING_ACCENT
      : EVENT_TYPE_ACCENT[typeKey] || EVENT_TYPE_ACCENT.EVENT;

  return {
    typeKey,
    isTesting,
    isBooking,
    isFull: maxParticipants > 0 && attendeesCount >= maxParticipants,
    eventTypeLabel: toEventTypeLabel(event?.eventType),
    statusLabel,
    statusColor,
    accentColor,
    attendeesCount,
    bookingRegistrationCount,
    maxParticipants,
    capacityPercent,
    rsvpZugesagt,
    rsvpAbgesagt,
    rsvpAusstehend,
    isPublicBookingEnabled:
      isBooking && Boolean(event?.isPublic) && Boolean(event?.registrationConfig?.isPublicRegistrationEnabled),
  };
};

export const getManageParticipantsConfig = (event) => {
  const metrics = getEventCardMetrics(event);

  if (metrics.isBooking) {
    return {
      label: "Anmeldungen",
      icon: "mdi:clipboard-list-outline",
      tooltip: "Anmeldungen öffnen und Buchungsstatus/Zahlungen verwalten",
    };
  }

  if (metrics.isTesting) {
    return {
      label: "Prüfungsliste",
      icon: "mdi:account-star-outline",
      tooltip: "Prüfungskandidaten aufstellen, RSVP-Status verwalten und Graduierungen durchführen",
    };
  }

  return {
    label: "Teilnehmer",
    icon: "mdi:account-multiple-plus",
    tooltip: "Angemeldete Teilnehmer einsehen, hinzufügen oder entfernen",
  };
};

export const getPublicBookingTooltip = (event, isPublicBookingEnabled) => {
  if (isPublicBookingEnabled) {
    return "Öffentliche Buchungsseite in neuem Tab öffnen";
  }

  if (!event?.isPublic) {
    return "Die Veranstaltung muss öffentlich sein.";
  }

  return 'Bitte "Öffentliche Anmeldung erlauben" in der Buchungskonfiguration aktivieren.';
};
